import React from "react";
import { s } from "./style";
import loginImage from "@shared/assets/images/login/loginImage.png";
import loginBackgroundLogo from "@shared/assets/images/login/loginBackgroundLogo.png";
import { LoginButton} from "@shared/ui/button/login-button";
import CustomCircularProgress from "@shared/ui/modal/LodingModal";
import { useLoginForm } from "../model/useLoginForm";

function LoginPage() {
    const {
        idText,
        setIdText,
        passwordText,
        setPasswordText,
        passwordInputRef,
        handleLoginClick,
        loading,
        error,
    } = useLoginForm();

    return (
        <>
            <CustomCircularProgress isOpen={loading} type="LOADING" />
            <s.LoginPageContainer>
                <s.LeftContainer>
                    <s.LoginContainer>
                        <s.LoginImage src={loginImage} alt="Balken Logo" />
                        <s.StyledInput
                            type="text"
                            value={idText}
                            onChange={(e) => setIdText(e.target.value)}
                            placeholder="아이디"
                            onKeyDown={(e) => e.key === "Enter" && passwordInputRef.current?.focus()}
                        />
                        <s.StyledInput
                            ref={passwordInputRef}
                            type="password"
                            value={passwordText}
                            onChange={(e) => setPasswordText(e.target.value)}
                            placeholder="비밀번호"
                            onKeyDown={(e) => e.key === "Enter" && handleLoginClick()}
                        />
                        <s.LoginButtonContainer>
                            <LoginButton
                                onClick={handleLoginClick}
                                height={45}
                                fontSize={16}
                                width={470}
                                disabled={loading}
                            >
                                {loading ? "로그인 중..." : "로그인"}
                            </LoginButton>
                        </s.LoginButtonContainer>
                        {error && <p style={{ color: "red", marginTop: "8px" }}>{error}</p>}
                    </s.LoginContainer>
                </s.LeftContainer>
                <s.RightContainer>
                    <s.SubText>이동 편의 토탈 솔루션</s.SubText>
                    <s.SubText2>발켄 모빌리티</s.SubText2>
                    <s.LoginLogo src={loginBackgroundLogo} alt="Login Logo" />
                </s.RightContainer>
            </s.LoginPageContainer>
        </>
    );
}

export default LoginPage;
